import React, { useState, useEffect } from 'react';
import { styled, Row, SubTitle, Col, Caption, Body } from '@teko/ds-desktop';
import { PromotionGroupType } from '@teko/cart/v2';
import { CautionOutlined, DownOutlined, UpOutlined } from '@teko/ds-icon';
import { getPromotionStatus } from '../../helpers/index.es.js';
import { t } from '../../i18n.es.js';
import { PromotionItem } from '../PromotionItem/PromotionItem.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledWarningTextRow = styled(Row)`
  padding: 12px 0px;
`;
const BlockPromotion = (_a) => {
  var _b = _a, {
    title,
    description,
    promotions,
    groupType,
    onApplyPromotion,
    onRemovePromotion,
    borderColor = "white",
    backgroundColor = "background",
    warningText,
    productId,
    styledTitle,
    showMore = 1e3,
    styledPromotionItem,
    productSku,
    comboPromotion
  } = _b, props = __objRest(_b, [
    "title",
    "description",
    "promotions",
    "groupType",
    "onApplyPromotion",
    "onRemovePromotion",
    "borderColor",
    "backgroundColor",
    "warningText",
    "productId",
    "styledTitle",
    "showMore",
    "styledPromotionItem",
    "productSku",
    "comboPromotion"
  ]);
  const [showPromotions, setShowPromotions] = useState([]);
  const isDefaultPromotionBlock = groupType ? groupType === PromotionGroupType.GROUP_TYPE_DEFAULT : promotions.every((value) => !value.isSelectable);
  return /* @__PURE__ */ React.createElement(Row, __spreadValues({
    borderColor,
    backgroundColor,
    justify: "start",
    borderRadius: "m",
    borderStyle: "solid",
    borderWeight: "m"
  }, props), /* @__PURE__ */ React.createElement(SubTitle, __spreadValues({
    level: 4,
    color: "textSecondary"
  }, styledTitle), title, /* @__PURE__ */ React.createElement("strong", {
    style: { fontWeight: "lighter", fontSize: "12px" }
  }, !!description ? ` (${description})` : ``)), showPromotions.map((promotion, index) => {
    const promotionStatus = getPromotionStatus(promotion.cartPromotionId, promotion.isSelectable, groupType);
    return /* @__PURE__ */ React.createElement(PromotionItem, __spreadValues(__spreadValues({
      key: `${promotion.promotionId}-${index}`,
      onApplyPromotion: () => onApplyPromotion == null ? void 0 : onApplyPromotion({
        productId,
        promotionCode: promotion.promotionCode,
        promotionId: promotion.promotionId
      }),
      onRemovePromotion: () => onRemovePromotion == null ? void 0 : onRemovePromotion(promotion.cartPromotionId),
      data: __spreadProps(__spreadValues({}, promotion), { productSku, comboPromotion, promotionStatus })
    }, styledPromotionItem), isDefaultPromotionBlock && promotion.cartPromotionId === null ? { opacity: "m" } : {}));
  }), !!warningText && /* @__PURE__ */ React.createElement(StyledWarningTextRow, {
    padding: "s16"
  }, /* @__PURE__ */ React.createElement(Col, {
    flex: "8%",
    style: { alignItems: "center", justifyContent: "center" }
  }, /* @__PURE__ */ React.createElement(CautionOutlined, {
    size: 13,
    color: "warning"
  })), /* @__PURE__ */ React.createElement(Col, {
    flex: "92%"
  }, /* @__PURE__ */ React.createElement(Caption, {
    level: 1,
    color: "warning"
  }, warningText))), /* @__PURE__ */ React.createElement(ScrollControlContainer, null, /* @__PURE__ */ React.createElement(ZoomOutListButton, {
    setShowList: setShowPromotions,
    originalList: promotions,
    size: showMore
  })));
};
const ZoomOutListButton = ({ setShowList, originalList, size = 2 }) => {
  const [loadMore, setLoadMore] = useState();
  const [index, setIndex] = useState(0);
  const buttonText = loadMore ? t("Xem th\xEAm") : t("R\xFAt g\u1ECDn");
  const buttonClassName = loadMore ? "att-block-promotion-load-more" : "att-block-promotion-collapse";
  useEffect(() => {
    if (originalList.length > size) {
      setShowList(originalList.slice(0, size));
      setIndex(size);
    } else {
      setShowList(originalList);
    }
  }, [originalList, size, setShowList]);
  useEffect(() => {
    if (size > 0 && originalList.length > size) {
      if (index >= originalList.length) {
        setLoadMore(false);
      } else {
        setLoadMore(true);
      }
    } else {
      setLoadMore(void 0);
    }
  }, [index, originalList.length, size]);
  const load = () => {
    if (index < originalList.length) {
      const newIndex = index + size;
      setShowList(originalList.slice(0, newIndex));
      setIndex(newIndex);
    } else {
      setShowList(originalList.slice(0, size));
      setIndex(size);
    }
  };
  if (loadMore === void 0)
    return null;
  return /* @__PURE__ */ React.createElement(Row, {
    width: 80,
    align: "middle",
    marginTop: "s12",
    onClick: load,
    className: buttonClassName
  }, /* @__PURE__ */ React.createElement(ClickText, {
    level: 1,
    marginRight: "s4",
    color: "textSecondary"
  }, buttonText), loadMore ? /* @__PURE__ */ React.createElement(DownOutlined, {
    color: "textSecondary"
  }) : /* @__PURE__ */ React.createElement(UpOutlined, {
    color: "textSecondary"
  }));
};
const ScrollControlContainer = styled.div`
  display: inline-block;
  margin: 0 auto;
`;
const ClickText = styled(Body)`
  user-select: none;
`;

export { BlockPromotion };
